import { render, staticRenderFns } from "./EgressProfileCompetence.vue?vue&type=template&id=33c572cc&scoped=true"
import script from "./EgressProfileCompetence.vue?vue&type=script&lang=js"
export * from "./EgressProfileCompetence.vue?vue&type=script&lang=js"
import style0 from "./EgressProfileCompetence.vue?vue&type=style&index=0&id=33c572cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c572cc",
  null
  
)

export default component.exports